<template>
  <div
    style="
      display: flex;
      margin-top: 25px;
      font-size: 14px;
      color: #666666;
      line-height: 40px;
    "
  >
    <div class="radioadd">
      <el-radio-group v-model="radiotype" @change="radiotypeFun">
        <el-radio label="上传文件">上传文件</el-radio>
        <el-radio label="在线录制">在线录制</el-radio>
      </el-radio-group>
    </div>
    <div v-if="radiotype == '上传文件'" style="width: 100%">
      <div style="display: flex; width: 100%; font-size: 14px; color: #666666">
        <span class="imp">上传语音:&nbsp;</span>
        <el-upload
          v-loading="loadingimg"
          style="flex: 1"
          class="upload-demo"
          accept=".mp3"
          :show-file-list="false"
          drag
          action="#"
          multiple
          :http-request="customUpload"
          :before-upload="beforeUpload"
          :auto-upload="true"
        >
          <svg
            style="margin-bottom: 10px"
            t="1754890564140"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="5132"
            width="65"
            height="50"
          >
            <path
              d="M512 144c158.0544 0 288.2816 119.0912 305.8688 272.4352a228.096 228.096 0 0 1-21.9392 455.0912H228.096a228.0704 228.0704 0 0 1-21.9392-455.0912C223.744 263.0912 353.9456 144 512 144z m0.768 220.0832h-0.2048a36.352 36.352 0 0 0-25.9584 10.6752l-146.7648 146.7648a36.48 36.48 0 1 0 51.6096 51.6096l84.0704-84.0704v219.776a36.48 36.48 0 1 0 72.96 0v-220.928l85.2224 85.2224 0.4096 0.4096a36.48 36.48 0 0 0 51.2-52.0192l-146.7648-146.7648-0.4352-0.4096a36.352 36.352 0 0 0-25.344-10.2656z"
              fill="#4283F4"
              p-id="5133"
            ></path>
          </svg>
          <div class="el-upload__text">
            将语音文件拖到此处，或<em>点击上传</em>
          </div>
          <div style="color: #999999; margin-top: -5px">
           语音时长不超过30秒，大小不超过2M，mp3格式
          </div>

          <!-- <div class="el-upload__tip" slot="tip">
                        只能上传jpg/png文件，且不超过500kb
                      </div> -->
        </el-upload>
      </div>
      <div style="color: #999" v-if="fileListData.name != ''">
        <i style="visibility: hidden" class="imp">输入问题:&nbsp;</i
        ><svg
          t="1755064262478"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="6309"
          width="20"
          height="20"
        >
          <path
            d="M511.3 109.8c111.1 0 201.1 90.1 201.1 201.1v180.7c0 111.1-90.1 201.1-201.1 201.1s-201.1-90.1-201.1-201.1V310.9c0-111.1 90-201.1 201.1-201.1zM360.5 388.1v103.4c0 83.3 67.5 150.9 150.9 150.9s150.9-67.5 150.9-150.9V388.1H360.5z m0-50.2h301.7v-27c0-7.2-0.5-14.3-1.5-21.3H536.5c-13.9 0-25.1-11.3-25.1-25.1s11.3-25.1 25.1-25.1h107.7c-25.5-47.2-75.4-79.3-132.8-79.3-83.3 0-150.9 67.5-150.9 150.9v26.9z m176 453.6v72.6h150.9c13.9 0 25.1 11.3 25.1 25.1 0 13.9-11.3 25.1-25.1 25.1h-352c-13.9 0-25.1-11.3-25.1-25.1 0-13.9 11.3-25.1 25.1-25.1h150.9v-72.6c-155-12.8-276.7-142.5-276.7-300.7v-50.3c0-13.9 11.3-25.1 25.1-25.1s25.1 11.3 25.1 25.1v50.3c0 138.9 112.6 251.4 251.4 251.4s251.4-112.6 251.4-251.4v-50.3c0-13.9 11.3-25.1 25.1-25.1 13.9 0 25.1 11.3 25.1 25.1v50.3c0.3 158.2-121.5 287.9-276.3 300.7z"
            p-id="6310"
          ></path></svg
        >{{ fileListData.name }}
      </div>
      <div
        style="
          display: flex;
          margin-top: 25px;
          font-size: 14px;
          color: #666666;
          line-height: 40px;
        "
      >
        <i style="visibility: hidden" class="imp">输入问题:&nbsp;</i>
        <div class="submit" @click="subb" v-loading="subloading">提交</div>
      </div>
    </div>
    <div v-else style="width: 100%">
      <div style="display: flex">
        <span class="imp">录制语音:&nbsp;</span>
        <div class="voice-recorder">
          <!-- 录音按钮           @mouseleave="cancelRecording"-->
          <div
            class="record-btn"
            @mousedown="startRecording"
            @mouseup="stopRecording"
            @touchstart="startRecording"
            @touchend="stopRecording"
          >
            <!-- <i :class="isRecording ? 'el-icon-loading' : 'el-icon-microphone'"></i> -->

            <svg
            style='margin-right:0'
              t="1755056725322"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4884"
              width="40"
              height="40"
            >
              <path
                d="M855.6544 472.9856a21.5552 21.5552 0 0 1 21.504 21.504v21.504A364.2112 364.2112 0 0 1 533.1712 880.384v100.608h93.952a21.504 21.504 0 0 1 0 43.008H412.16a21.504 21.504 0 0 1 0-43.008h78.0544v-100.608A364.1856 364.1856 0 0 1 146.176 515.968v-21.504a21.504 21.504 0 1 1 43.008 0v21.504a322.5344 322.5344 0 0 0 322.4576 322.5088 322.4832 322.4832 0 0 0 322.4832-322.5088v-21.504a21.5552 21.5552 0 0 1 21.504-21.504zM511.616 0a215.0144 215.0144 0 0 1 215.0144 214.9888v301.0048a215.0144 215.0144 0 0 1-430.0032 0V214.9888A215.04 215.04 0 0 1 511.616 0z"
                fill="#4384F4"
                p-id="4885"
              ></path>
            </svg>
          </div>
          <span>
            {{
              isRecording ? recordingTime + "s / 最长录制30s" : recordText
            }}</span
          >
          <!-- 录音提示 -->
          <!-- <p v-if="isRecording" class="recording-tip">
          {{ recordingTime }}s / 最长录制30s        </p> -->
          <!-- 录音动画 -->
          <div v-if="isRecording" class="recording-animation">
            <img src="../assets/ypbd.gif" width="100%" />
            <!-- <div class="wave" :style="{ height: volumeHeight + '%' }"></div> -->
          </div>
          <div
            v-if="!isRecording && wavBlob !== null"
            style="display: flex; flex-direction: column; align-items: center"
          >
            <img src="../assets/ypbd.png" width="100%" />
            <div class="pf" v-loading='fileshow==""'>
          {{ isPlaying ? '暂停': '播放'}}
              <div style="position: absolute; left: 0; top: 0">
                <button
                  @click="togglePlay"
                  style="width:78px;height: 32px; cursor: pointer;opacity: 0;"
                >
            {{ isPlaying ? '暂停': '播放'}}
                </button>
                <audio ref="audioPlayer" :src="fileshow" preload="auto" @ended="onAudioEnded"></audio>
              </div>
            </div>
          </div>

          <!-- 录音结果 -->
          <div v-if="audioUrl" class="audio-preview">
            <audio controls :src="audioUrl"></audio>
            <el-button size="mini" @click="sendAudio">发送</el-button>
            <el-button size="mini" @click="cancelAudio">取消</el-button>
          </div>
        </div>
      </div>
      <div
        style="
          display: flex;
          margin-top: 25px;
          font-size: 14px;
          color: #666666;
          line-height: 40px;
        "
      >
        <i style="visibility: hidden" class="imp">输入问题:&nbsp;</i>
        <div class="submit" @click="subb" v-loading="subloading">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import Recorder from "js-audio-recorder";
import AudioPlayer from "@/components/AudioPlayer.vue";
// import LAMP from 'lampjs';
// 正确方式（适用于 CommonJS 模块）
// import LAMP from "lampjs"; // 正确（如果 lampjs 是 ES6 模块）

export default {
  components: {
    AudioPlayer,
  },

  props: {
    subloading: false,
  },
  data() {
    return {
      isPlaying: false,
      wavBlob: null,
      imgpath: "",
      loadingimg: false,
      radiotype: '上传文件',
      recorder: null,
      lamp: null,
      isRecording: false,
      audioUrl: null,
      audioBlob: null,
      recordingTime: 0,
      timer: null,
      volumeHeight: 10,
      recordText: '鼠标左键按住图标开始录制语音，时长不超过30秒',
      maxDuration: 30, // 最大录音时长（秒）
      fileListData: { name: "" },
      fileurl: "",
      fileshow: "",
    };
  },
  mounted() {
    // 初始化 LAMP（用于 WAV 转 MP3）
    // this.lamp = LAMP.someMethod()//new LAMP();
    console.log(this.lamp);
  },
  methods: {
    onAudioEnded(){
                this.isPlaying = false;
    },
    togglePlay() {
      const audio = this.$refs.audioPlayer;
      if (audio) {
        try {
          if (this.isPlaying) {
            audio.pause();
          } else {
            audio.play();
          }
          this.isPlaying = !this.isPlaying;
          this.$emit("isPlayingf", this.isPlaying);
        } catch (error) {
          console.error("音频操作失败:", error);
        }
      }
    },
    isPlayingf(val) {
      this.isPlaying = val;
    },
    customUpload(options) {
      this.loadingimg = true;
      const formData = new FormData();
      formData.append("op", "");
      formData.append("file", options.file);
      let _this = this;
    this.$axios
        .post( "/fileUpload.do", formData,  
        {headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          }})

        .then(function (response) {
          console.log(response);
          _this.loadingimg = false;
          if (response.data.value == "ok") {
            _this.fileListData.name = response.data.name;
            _this.fileurl = options.file; //res.data.view_url;

            // // _this.sczlData.push(response.data)
            // // console.log(' _this.sczlData', _this.sczlData)
            // // _this.fileList[_this.fileList.length - 1].fid = response.data.fid;
            // // console.log("  _this.fileList  _this.fileList", _this.fileList);
            // _this.imgpath = require("../assets/72.mp3"); //response.data.url;
          } else if (response.data.value == "sessionerror") {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
            _this.$router.push({ path: "/" });
            window.localStorage.setItem("loginName", "");
            window.sessionStorage.setItem("get_userinfo_qx", "");
          } else {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      // if (this.fileList.length == 11) {
      //   this.$message.error("文件最多上传10个");
      //   return false;
      // }

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isLt2M;
    },
    // 开始录音
    async startRecording(e) {
      this.fileshow= ''
      e.preventDefault(); // 防止移动端触屏事件冲突
      this.resetRecording();

      try {
        // 初始化录音器
        this.recorder = new Recorder({
          sampleBits: 16, // 采样位数
          sampleRate: 16000, // 采样率
          numChannels: 1, // 单声道
        });

        // 开始录音
        this.recorder.start().then(() => {
          this.isRecording = true;
          this.recordText = "";

          // 计时器
          this.timer = setInterval(() => {
            this.recordingTime++;
            if (this.recordingTime >= this.maxDuration) {
              this.stopRecording();
            }
          }, 1000);

          // 监听音量变化（用于动画）
          this.recorder.onprogress = (params) => {
            this.volumeHeight = Math.min(100, params.volume * 100);
          };
        });
      } catch (error) {
        console.error("录音启动失败:", error);
        this.$message.error("录音启动失败，请检查麦克风权限");
      }
    },

    // 停止录音（发送）
    stopRecording() {
      if (!this.isRecording) return;

      clearInterval(this.timer);
      this.isRecording = false;
      this.recordText =  '鼠标左键按住图标开始录制语音，时长不超过30秒';

      // 停止录音
      this.recorder.stop();

      // 获取 WAV 格式音频
      const wavBlob = this.recorder.getWAVBlob();
      console.log(wavBlob);
      this.wavBlob = wavBlob;
      this.fileurl = wavBlob;
      const formData = new FormData();
      formData.append("op", "");
      formData.append("file", wavBlob);
      let _this = this;
    this.$axios
        .post( "/fileUpload.do", formData,  
        {headers: {
            Authorization:
              window.localStorage.getItem("anjing_name_token") || "",
          }})

        .then(function (response) {
          console.log(response);
          _this.loadingimg = false;
          if (response.data.value == "ok") {
            _this.fileshow = response.data.view_url;
            console.log(" _this.fileshow ", _this.fileshow);
            // _this.fileurl = options.file//res.data.view_url;
          } else if (response.data.value == "sessionerror") {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
            _this.$router.push({ path: "/" });
            window.localStorage.setItem("loginName", "");
            window.sessionStorage.setItem("get_userinfo_qx", "");
          } else {
            _this.$message({
              message: response.data.msg,
              showClose: true, // 显示关闭按钮
              type: "error", // 可选类型：success/warning/info/error
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      // this.transcribeAudio(wavBlob);

      // 转换为 MP3（可选）
      // this.convertToMP3(wavBlob);

      // 或者直接使用 WAV（如果不需要 MP3）
      // this.audioBlob = wavBlob;
      // this.audioUrl = URL.createObjectURL(wavBlob);
    },

    // 取消录音（上滑取消）
    cancelRecording() {
      if (!this.isRecording) return;

      clearInterval(this.timer);
      this.isRecording = false;
      this.recordText =  '鼠标左键按住图标开始录制语音，时长不超过30秒';
      this.recorder.stop();
      this.$message.info("已取消录音");
    },

    // WAV 转 MP3
    convertToMP3(wavBlob) {
      const reader = new FileReader();
      let _this = this;
      reader.onload = (e) => {
        const arrayBuffer = e.target.result;
        _this.lamp.ready(() => {
          const mp3Blob = _this.lamp.encode(arrayBuffer);
          _this.audioBlob = mp3Blob;
          _this.audioUrl = URL.createObjectURL(mp3Blob);
        });
      };
      reader.readAsArrayBuffer(wavBlob);
    },

    // 发送录音
    sendAudio() {
      if (!this.audioBlob) return;

      // 1. 上传到服务器（示例）
      const formData = new FormData();
      formData.append("audio", this.audioBlob, "recording.mp3");

      // 2. 模拟上传（实际项目中替换为 API 调用）
      setTimeout(() => {
        this.$message.success("发送成功");
        this.resetRecording();
      }, 1000);
    },

    // 取消录音
    cancelAudio() {
      this.resetRecording();
      this.$message.info("已取消");
    },

    // 重置录音状态
    resetRecording() {
      this.isRecording = false;
      this.audioUrl = null;
      this.audioBlob = null;
      this.recordingTime = 0;
      this.volumeHeight = 10;
      clearInterval(this.timer);
    },
    radiotypeFun() {
      this.fileurl = "";
    },
    subb() {
      if (this.radiotype == '上传文件') {
        if (this.fileurl == "") {
          this.$message({
            message: '请上传语音文件',
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          return;
        }
      } else {
        if (this.fileurl == "") {
          this.$message({
            message: '请先录制语音',
            showClose: true, // 显示关闭按钮
            type: "error", // 可选类型：success/warning/info/error
          });
          return;
        }
      }
      this.$emit("yyFun", { file: this.fileurl });
    },
  },
};
</script>

<style scoped>
.voice-recorder {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  flex: 1;
      border-radius: 10px;
  border: 1px dashed #d5ddeb;
}

.record-btn {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  /* background: #409eff; */
  border: 1px solid #409eff;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); */
}

.record-btn:active {
  background: #f6fbff;
}

.recording-animation {
  margin-top: 20px;
  width: 100px;
  height: 50px;
  display: flex;
  align-items: flex-end;
  width: 100%;
}

.wave {
  width: 100%;
  background: #409eff;
  transition: height 0.1s;
}

.recording-tip {
  margin-top: 10px;
  color: #999;
}

.audio-preview {
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.audio-preview audio {
  margin-right: 10px;
}
.imp {
  width: 100px;
  display: inline-block;
  height: auto;
  background: transparent;
  margin-right: 0;
}
.en .imp{
      width: 126px;
}
.radioadd {
  position: absolute;
  top: -7px;
  right: 33px;
}
/deep/.el-upload__text {
  font-size: 14px;
  color: #4283f4;
}
/deep/.el-upload-dragger {
  border: 1px dashed #d5ddeb;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
/deep/.el-upload {
  width: 100%;
}
.imgpath:hover .imgset {
  display: flex;
}
.imgpath:hover .imgmask {
  display: block;
}
.imgmask {
  position: absolute;
  background: #000;
  opacity: 0.5;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
}
.imgset {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  display: none;
}
svg {
  vertical-align: sub;
}
.pf {
  /* cursor: pointer; */
  position: relative;
  background: rgb(82, 196, 116);
  width: 78px;
  text-align: center;
  /* padding: 0px 10px; */
  color: #fff;
  border-radius: 6px;
    text-align: center;
  /* height: 22px; */
  font-size: 14px;
  height: 32px;
  line-height: 32px;
  cursor: pointer;
}
.submit {
  background: #4384f4;
  color: #fff;
  height: 40px;
  line-height: 40px;
  text-align: center;
  flex: 1;
  /* margin-left: 20px; */
  border-radius: 6px;
  cursor: pointer;
      font-size: 16px;
}
@media screen and (max-width: 1600px) {
  .submit{
    font-size:14px;
  }
}
</style>